/*
 * @Description: 首页
 * @Author: ma.cq
 * @Date: 2018-10-09 19:00:13
 * @LastEditors: ma.cq
 * @LastEditTime: 2018-11-09 19:17:41
 */
<template>
  <div class="home">
    <panel title="快捷菜单" icon="shezhi" @iconClick="setMenu">
      <ul class="menu-list">
        <li v-for="item in menuList" :key="item.title">
          <router-link :to="item.path">
            <svg class="icon" aria-hidden="true">
              <use :xlink:href="`#icon-${item.icon}`"></use>
            </svg>
            <p class="title">{{item.title}}</p>
          </router-link>
        </li>
        <div class="tag-nolist" v-if="menuList.length === 0">未设置快捷菜单</div>
      </ul>
    </panel>
    <el-row class="info-todo" :gutter="10">
      <el-col :span="12">
        <panel title="通知">
          <div class="info">
            <el-row v-for="(item, index) in infoList" :key="index" class="info-list" :gutter="2">
              <el-col :span="17" class="info-todo-title" :title="item.title">{{item.title}}</el-col>
              <el-col :span="5">{{item.time}}</el-col>
              <el-col :span="2" class="check-btn">
                <router-link :to="item.path">查看</router-link>
              </el-col>
            </el-row>
          </div>
        </panel>
      </el-col>
      <el-col :span="12">
        <panel title="待办事项">
          <div class="todo">
            <el-row v-for="(item, index) in todoList" :key="index" class="info-list" :gutter="2">
              <el-col :span="22" class="info-todo-title" :title="formatTodoTitle(item.type, item.num)">{{formatTodoTitle(item.type, item.num)}}</el-col>
              <el-col :span="2" class="check-btn">
                <router-link :to="item.path">查看</router-link>
              </el-col>
            </el-row>
          </div>
        </panel>
      </el-col>
    </el-row>
    <setting-dialog :show.sync="settingDialogShow" :checkedList="menuList" />
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import Panel from './panel'
import SettingDialog from './settingDialog'

export default {
  name: 'home',
  components: { Panel, SettingDialog },
  data () {
    return {
      infoList: [
        {
          title: '你好啊，我是通知1号，我很机智',
          time: '08/09 12:00',
          path: '/orderManager/orderManager'
        },
        {
          title: '你好，我是通知2号，我比较高冷',
          time: '05/06 01:11',
          path: '/productManager/classifyManager'
        }
      ],
      todoList: [
        {
          type: 1,
          num: '1',
          path: '/orderManager/orderManager'
        },
        {
          type: 2,
          num: '2',
          path: '/productManager/classifyManager'
        }
      ],
      settingDialogShow: false
    }
  },
  computed: {
    ...mapState({
      list: state => state.home.homeRoutes
    }),
    // 有权限的路由表
    routes () {
      const r = this.$router.options.routes[0].children
      const formatRoutes = r.map(item => {
        const icon = item.meta.parent ? item.meta.parent.icon : 'gongzuotai'
        const parentTitle = item.meta.parent ? item.meta.parent.title : '父路由'
        return {
          code: item.code,
          path: item.path,
          title: item.meta.title,
          icon,
          parentTitle
        }
      })
      return formatRoutes
    },
    // 快捷路由
    menuList () {
      const codeList = this.list.map(item => {
        return item.code
      })
      const mList = this.routes.filter(item => {
        return codeList.find(code => code === item.code)
      })
      return mList
    }
  },
  mounted () {
    this.getHomeRoutes()
    let user = this.$storage.getItem(this.$storage.keys.USER_INFO) || {}
    var hostname = window.location.hostname
    var srcZhuShou = ''
    var cardSolutionId = user.cardSolution
    let cardSolution = cardSolutionId.replace(/^0+/, '')
    console.log(cardSolution)
    var add = '&account=' + cardSolution
    if (hostname === '39.105.116.85') {
      srcZhuShou = 'http://wxtest.bondway.net:8085/warning-service/assets/common/js/jichengzujianbox.js?sysInfoId=978' + add
    } else if (hostname === '39.105.199.15') {
      srcZhuShou = 'http://wxtest.bondway.net:8085/warning-service/assets/common/js/jichengzujianbox.js?sysInfoId=978' + add
    } else if (hostname === 'sh.jbestore.com' || hostname === '39.107.206.22') {
      srcZhuShou = 'https://devops.bondway.net:41234/warning-service/assets/common/js/jichengzujianbox.js?sysInfoId=978' + add
    } else if (hostname === 'localhost') {
      srcZhuShou = 'http://wxtest.bondway.net:8085/warning-service/assets/common/js/jichengzujianbox.js?sysInfoId=978' + add
    }
    var hm = document.createElement('script')
    hm.type = 'text/javascript'
    hm.src = srcZhuShou
    hm.id = 'gongxiangkefu'
    hm.crossorigin = true
    var s = document.getElementsByTagName('head')[0]
    s.parentNode.insertBefore(hm, s)
  },
  methods: {
    ...mapActions(['getHomeRoutes', 'setHomeRoutes']),
    setMenu () {
      // 打开配置弹出层
      this.settingDialogShow = true
    },
    formatTodoTitle (type, num) {
      const typeMap = {
        1: '个客户授信，等待您审核！',
        2: '个订单等待您审核！'
      }
      return num + typeMap[type]
    }
  }
}
</script>
<style lang="scss" scoped>
.home{
  padding: 0 !important;
  background-color: #f7f7f7 !important;
}
.menu-list{
  overflow: hidden;
  min-height: 240px;
  >li{
    position: relative;
    box-sizing: border-box;
    float: left;
    width: 120px;
    text-align: center;
    height: 120px;
    padding: 16px;
    &:not(:last-child):not(:nth-child(5n))::before{
      content: '';
      position: absolute;
      right: 0;
      top: 50%;
      height: 24px;
      width: 1px;
      transform: translateY(-50%);
      background-color: #d8d8d8;
    }
    >a{
      display: block;
      .icon{
        width: 36px;
        height: 36px;
        color: $primary-color;
        transition: transform .5s;
      }
      .title{
        margin-top: 20px;
        font-size: 14px;
        color: #666;
        transition: color .5s;
      }
    }
    >a:hover{
      .icon{
        transform: translateY(-2px);
      }
      .title{
        color: $primary-color;
      }
    }
  }
  .tag-nolist {
    line-height: 240px;
    text-align: center;
  }
}
.info-todo{
  margin-top: 30px;
}
.info,.todo{
  line-height: 24px;
  min-height: 180px;
  padding: 20px;
  font-size: 14px;
  >*{
    color: #222;
    transition: color .5s;
  }
  .info-todo-title{
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
  .check-btn{
    color: $primary-color;
  }
}
</style>
